/**
 * Яндекс.Метрика (счётчик 110921828) — цели воронки.
 *
 * Сам счётчик подключается в public/index.html (defer: true — хиты страниц
 * отправляет App.tsx::MetrikaRouteTracker при каждой смене маршрута SPA).
 * Вебвизор ВЫКЛЮЧЕН: в анкете вводятся данные о здоровье (ст. 10 152-ФЗ).
 *
 * Проверка в консоли браузера: открыть страницу с ?_ym_debug=1 — Метрика сама
 * печатает отправленные цели, плюс эта обёртка пишет «[Metrika] goal …».
 */

export const METRIKA_ID = 110921828;

export type MetrikaGoal =
  | 'webapp_open'
  | 'quiz_start'
  | `quiz_step_${number}`
  | 'quiz_complete'
  | 'result_view'
  | 'email_submit'
  | 'magiclink_sent'
  | 'magiclink_opened'
  | 'code_entered' // В2: вход кодом из письма удался
  | 'code_failed'  // В2: код не подошёл / устарел (error — почему)
  | 'account_created'
  | 'tg_auth'
  | 'tg_continue'
  | 'paywall_view'
  | 'checkout_start_599'
  | 'checkout_start_1490'
  | 'purchase_success'
  | 'domain_fallback'; // №64: заглушка «Сайт не открылся» перевела на второй адрес (from — откуда)

type YmFn = (id: number, method: string, ...args: unknown[]) => void;

function isDebug(): boolean {
  try {
    return (
      window.location.search.includes('_ym_debug=1') ||
      localStorage.getItem('aisha_metrika_debug') === '1'
    );
  } catch {
    return false;
  }
}

// Цели, которые должны уйти один раз за вкладку (перерисовки React их не дублируют)
const sentOnce = new Set<string>();

/** Отправить цель. Никогда не бросает исключений — аналитика не ломает UX. */
export function reachGoal(goal: MetrikaGoal, params?: Record<string, unknown>, opts?: { once?: boolean }): void {
  try {
    if (opts?.once) {
      if (sentOnce.has(goal)) return;
      sentOnce.add(goal);
    }
    if (isDebug()) {
      // eslint-disable-next-line no-console
      console.info('[Metrika] goal', goal, params ?? '');
    }
    const ym = (window as unknown as { ym?: YmFn }).ym;
    if (typeof ym === 'function') {
      ym(METRIKA_ID, 'reachGoal', goal, params);
    }
  } catch {
    /* не мешаем пользователю */
  }
}

/** Хит просмотра страницы для SPA (счётчик инициализирован с defer: true). */
export function trackPageView(url: string): void {
  try {
    const ym = (window as unknown as { ym?: YmFn }).ym;
    if (typeof ym === 'function') {
      ym(METRIKA_ID, 'hit', url, { referer: document.referrer });
    }
  } catch {
    /* ignore */
  }
}
